import {useMemo, useState} from 'react';
import {useSelector} from 'react-redux';

import {selectRoute} from '../store/data/page';
import {useGeneralProvider} from 'brandComponents/_app-config/GeneralProvider';

import {getPageTypeFromUrl} from 'coreUtils/url';

import {RootState} from 'coreStore/types';
import {PageType} from 'coreUtils/IUtils';

import {useIsNavigatingAway} from './NavigationContext';

export default () => {
	const {isAppLoading} = useGeneralProvider();
	const isNavigating = useIsNavigatingAway();
	const isLocked = isAppLoading || isNavigating;
	const route = useSelector((state: RootState) => selectRoute(state));
	const [frozenRoute, setFrozenRoute] = useState(route);

	// Freeze the route while a navigation is in flight: the new page dispatches
	// receiveRoute before the transition commits, so shell components must keep
	// the previous page's route until the new page is actually visible.
	if (!isLocked && frozenRoute !== route) {
		setFrozenRoute(route);
	}

	const pageType = useMemo(() => getPageTypeFromUrl(frozenRoute.currentRoute), [frozenRoute.currentRoute]);

	return useMemo(
		() => ({
			...frozenRoute,
			pageType,
			isPDP: pageType === PageType.PDP,
			isPLP: pageType === PageType.PLP,
			isHomePage: frozenRoute.isHomePage,
			isSplashPage: pageType === PageType.SplashPage,
			is404: pageType === PageType.NOT_FOUND,
			isEditorial: pageType === PageType.Editorial,
			isMyAccount: pageType === PageType.MY_ACCOUNT
		}),
		[frozenRoute, pageType],
	);
};
